import styled from 'styled-components';
export const ModalContainer = styled.div ``;
export const Backdrop = styled.div `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    // Setting pointer-events to auto so it works over embedded ad UI
    pointer-events: auto;
`;
//# sourceMappingURL=index.js.map